// src/pages/Products.js 
// (Assuming this file contains your Products component)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar';
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';

// Page Component
import ProductGrid from './PageComponent/Backup_products';

function Products() {

  // The useMeta hook call is removed and its content is moved into <Helmet>
  return (
    <>
      <Helmet>
        {/* Primary SEO Tags */}
        <title>Discover stunning array of Window Fashion where style meets luxury</title>
        <meta
          name="description"
          content="We manufacture blinds having accuracy with variety of fabrics, designs and operating systems prioritizing commitment to quality and innovation"
        />
        <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/products/`} />

        {/* Open Graph Tags (for Social Media) */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Discover stunning array of Window Fashion where style meets luxury" />
        <meta
          property="og:description"
          content="We manufacture blinds having accuracy with variety of fabrics, designs and operating systems prioritizing commitment to quality and innovation"
        />
        <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/products/`} />
        <meta property="og:site_name" content="Marvel Blinds" />
      </Helmet>

      {/* Rest of your component structure */}
      <div>
        <Navbar />
        <NotificationBar />
        <ProductGrid />
        <Footer />
      </div>
    </>
  );
}

export default Products;